import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import fieldNames from '../constants/field-names';
import createPhoneValidator from '../validators/create-phone-validator';

const { InputGroupField } = designSystem;

function PhoneField({ control, onChange, onClick }) {
  const handleChange = useCallback(
    (value) => {
      onChange({
        fieldName: fieldNames.PHONE_REFERENCE,
        fieldValue: value,
      });
    },
    [onChange]
  );

  const handleClick = useCallback(() => {
    onClick({ fieldName: fieldNames.PHONE_REFERENCE });
  }, [onClick]);

  return (
    <InputGroupField
      name={fieldNames.PHONE_REFERENCE}
      control={control}
      placeholder="+1-234-5678910"
      rules={{ validate: createPhoneValidator() }}
      onChange={handleChange}
      onClick={handleClick}
    />
  );
}

PhoneField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PhoneField;
